import { render } from "./AppFooter.vue?vue&type=template&id=e59df82c&scoped=true&ts=true"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"

import "./AppFooter.vue?vue&type=style&index=0&id=e59df82c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e59df82c"]])

export default __exports__